import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 더보기 ")

import {computed, ref, toRefs} from 'vue'
import {AgBoxS, AgIconS} from '@/components/ag'
import DoneClubDeal from './DoneClubDeal.vue'


export default /*#__PURE__*/_defineComponent({
  props: {
  list: {default: () => ([]), type: Array},
  step: {default: 3, type: Number},
},
  setup(__props) {

const props = __props



const {list, step} = toRefs(props)

const maxCount = computed(() => {
  return list.value.length
})

const showingCount = ref(maxCount.value < step.value ? maxCount.value : step.value)

const computedList = computed(() => {
  return list.value.map((item: any) => {
    return {
      endDate: item.dueDateFrom,
      id: String(item.partnershipId),
      name: item.partnershipName,
      price: Number(item.expectPrice ?? 0),
    }
  })
})

const showingList = computed(() => {
  return computedList.value.slice(0, showingCount.value)
})

const increaseShowingCount = () => {
  showingCount.value += step.value
  if (showingCount.value > maxCount.value) {
    showingCount.value = maxCount.value
  }
}

const isEndOfList = computed(() => {
  return showingCount.value >= maxCount.value
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(AgBoxS), null, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(showingList), (item) => {
        return (_openBlock(), _createBlock(DoneClubDeal, _mergeProps({
          key: item.id
        }, item), null, 16))
      }), 128)),
      _createVNode(_unref(AgBoxS), {
        "container-as": "button",
        disabled: _unref(isEndOfList),
        css: {
        width: '100%',
        bg: 'transparent',
        dp: 'flex',
        direction: 'row',
        justifyContent: 'center',
        height: 40,
        alignItems: 'center',
        mt: 8,
      },
        onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: 'company', 'clickArea':'마감된 클럽딜', 'clickContent': '더보기'});increaseShowingCount()})
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(AgBoxS), { css: {color: 'font', typography: 'main14r'} }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }),
          _createVNode(_unref(AgIconS), {
            name: "chevronDown",
            css: {color: 'gray2', width: 16, height: 16}
          })
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    _: 1
  }))
}
}

})